import { render, staticRenderFns } from "./StudentDetailsModal.vue?vue&type=template&id=ae90d87e&scoped=true"
import script from "./StudentDetailsModal.vue?vue&type=script&lang=js"
export * from "./StudentDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./StudentDetailsModal.vue?vue&type=style&index=0&id=ae90d87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90d87e",
  null
  
)

export default component.exports